module.exports = __webpack_public_path__ + "img/mini-010.49669469.jpg";